import React from "react";
import { useNavigate } from "react-router-dom";

const Tours = () => {
  const navigate = useNavigate();

  const tours = [
    {
      name: "Char Dham Yatra",
      description: "Visit Yamunotri, Gangotri, Kedarnath, and Badrinath. (9-10 days)",
      price: "₹45,000",
    },
    {
      name: "Rishikesh & Haridwar",
      description: "Explore spiritual & adventure places. (2 days)",
      price: "₹6,000",
    },
    {
      name: "Mussoorie Tour",
      description: "A trip to the Queen of Hills. (1 day)",
      price: "₹4,500",
    },
  ];

  const cardStyle = {
    border: "1px solid #ddd",
    margin: "10px",
    padding: "10px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  };

  const buttonStyle = {
    marginTop: "10px",
    padding: "8px 16px",
    fontSize: "14px",
    backgroundColor: "#007BFF",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  };

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h1>Our Tour Packages</h1>
      {tours.map((tour, index) => (
        <div key={index} style={cardStyle}>
          <h2>{tour.name}</h2>
          <p>{tour.description}</p>
          <strong>{tour.price}</strong>
        </div>
      ))}

      {/* Custom Trip Card */}
      <div style={cardStyle}>
        <h2>Make Your Own Custom Trip</h2>
        <p>Want a personalized tour plan? Contact us directly for custom itineraries.</p>
        <button style={buttonStyle} onClick={() => navigate("/contact")}>
          Contact Us
        </button>
      </div>
    </div>
  );
};

export default Tours;
